import React  from 'react';
import { useLivePreview } from '@payloadcms/live-preview-react';

import {
    Box,
    Container,
} from '@saladbob/sassafras'

import getSite from '../crud/getSite';
import getPageBySlug from '../crud/getPageBySlug';
import Blocks from '../components/blocks/Blocks';
import Layout from '../components/Layout';
import type { NextPageWithLayout, PageProps } from './_app'

import type { Page } from '../types';

type Props = {
    page: Page,
    payloadUrl,
    Header: React.FC,
};

export async function getStaticPaths() {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/pages?depth=0`);
    const pages = await res.json();

    return {
        paths: pages.docs.map(page => ({ params: { slug: page.slug } })),
        fallback: 'blocking', // can also be true or 'blocking'
    }
}

export async function getStaticProps({ params }) {
    if (!params.slug || params.slug === 'undefined') {
        return {
            notFound: true,
        }
    }

    const site = await getSite();
    const page = await getPageBySlug(params.slug);

    if (!page) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            metaTitle: page.title,
            page,
            ...site,
        },
    }
}

const Page: NextPageWithLayout<Props> = ({ page }) => {
    return (
        <Box bgColor="neutral50">
            <Container size="lg">
                <Box bgColor="white">
                    <Blocks blocks={page.layout} />
                </Box>
            </Container>
        </Box>
    );
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps ) {
    return (
        <Layout { ...pageProps }>
            {page}
        </Layout>
    )
}

export default Page;